module.exports = __webpack_public_path__ + "img/Q3.9f99124e.png";